import util from '@bmp-vue/core/api/util'

const controller = 'CentralEmailAdmin'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  EnviarEmail: function (dto) {
    return util.Axios.Put(controller + '/EnviarEmailAdmin', dto.codigo, dto)
  },
})
